import React, { useEffect, useState } from "react";
import AttachmentViewer from "../../../../app/core/components/AttachmentViewer/AttachmentViewer";
import { Backdrop, Chip } from "@mui/material";
import Dots from "../../../common/LoadingStuff/Dots";
import { t } from "i18next";

const DocPreview = ({
  selectedFile,
  boundingBox,
  isAIDocumentDataLoading,
  isDocumentDataError,
}) => {
  const [fileUrl, setFileUrl] = useState();

  useEffect(() => {
    if (selectedFile) {
      const fileUrl = URL.createObjectURL(selectedFile);
      setFileUrl(fileUrl);
    }
    if (!selectedFile) setFileUrl(null);
  }, [selectedFile]);

  return (
    <div
      style={{
        border: "1px solid #0000001f",
        opacity: isDocumentDataError ? "50%" : "100%",
        height: "87vh",
      }}
      className="w-full xl:w-7/12 p-2 rounded-md shadow-md bg-zinc-50 relative"
    >
      {!selectedFile && (
        <Chip
          label={t("Preview")}
          variant="outlined"
          className=" absolute top-5 right-8"
        />
      )}
      <div className="w-full">
        <Backdrop
          className="backdrop-animation"
          sx={{
            position: "absolute",
            zIndex: 2,
            borderRadius: 2,
          }}
          open={isAIDocumentDataLoading}
        />

        {isDocumentDataError && (
          <>
            <Backdrop
              color="red"
              sx={{
                position: "absolute",
                zIndex: 2,
                borderRadius: 2,
                backgroundColor: "rgba(255, 0, 0, 0.075)",
              }}
              open={isDocumentDataError}
            >
              <p className="text-red-600 italic font-semibold text-center">
                {t("ErrorRetrievingCategoriesData")}
              </p>
            </Backdrop>
          </>
        )}
        {isAIDocumentDataLoading && <Dots />}
        {fileUrl && (
          <div className="w-full absolute">
            <AttachmentViewer
              localUrl={fileUrl}
              files={[selectedFile]}
              boundingBox={isDocumentDataError ? undefined : boundingBox}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DocPreview;
